export default "/_next/static/chunks/fonts/Channel4Horseferry-Bold-9b79b81c44ed8dbdf5445fbe5cb485f6.woff";